import { Logo } from '@medly-components/core';
import { FC, memo } from 'react';

import { useSideNavContext } from 'context';
import { ReactComponent as NameLogo } from '../../../common/Logo/NameLogo.svg';
import { ReactComponent as ShortLogo } from '../../../common/Logo/ShortLogo.svg';
import { useSideNavHoverContext } from '../SideNav.context';
import { SidenavHeaderWrapper } from './SidenavHeader.styled';

export const SidenavHeader: FC = memo(() => {
    const isHovered = useSideNavHoverContext();
    const { isExpanded } = useSideNavContext();

    return (
        <SidenavHeaderWrapper as="div" isHovered={isHovered} isExpanded={isExpanded}>
            <Logo name={<NameLogo />} logo={<ShortLogo />} />
        </SidenavHeaderWrapper>
    );
});

SidenavHeader.displayName = 'SidenavHeader';
